export default "__VITE_ASSET__DrFXY4ye__"